import React, { Suspense, lazy } from 'react';
import './App.css';
import './css/bootstrap.min.css';
import './css/animate.css';
import './css/drift-basic.min.css';
import './css/flaticon.css';
import './css/font-awesome.min.css';
import './css/global.css';
import './css/home15.css';
import './css/magnific-popup.css';
// import './css/owl.carousel.min.css';
import './css/owl.theme.css';
import './css/royal-preload.css';
import './css/woocommerce.css';
import { Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ServicesPageEntry = lazy(() => import('./pages/ServicesPageEntry'));
const Projects = lazy(() => import('./pages/Projects'));
const Error404 = lazy(() => import('./pages/Error404'));

function App() {
  return (
   <>
   <NavBar/>
   <Suspense fallback={<div className="container py-5 text-center">Loading...</div>}>
     <Routes>
       <Route path='*' element={<Error404/>}></Route>
       <Route path='/' element={<HomePage/>}></Route>
       <Route path='/about' element={<AboutUs/>}></Route>
       <Route path='/contacts' element={<ContactPage/>}></Route>
       <Route path='/services' element={<ServicesPageEntry/>}></Route>
       <Route path='/projects' element={<Projects/>}></Route>
       <Route path='/blogs' element={<BlogPage/>}></Route>
     </Routes>
   </Suspense>
  
   <Footer/>
   </>
  );
}

export default App;
